import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../utils/api';
import '../styles/global.css';

export default function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role') || 'tenant';
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { ...data, role });
      setSent(true);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="topbar">
        <div className="topbar-logo"><div className="topbar-logo-dot" />Affordable Telecom LLC</div>
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          {!sent ? (
            <>
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--navy)', marginBottom: 6 }}>Forgot your password?</h1>
                <p style={{ color: 'var(--text-sub)', fontSize: 14 }}>Enter your email and we'll send you a reset link.</p>
              </div>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label className="form-label" htmlFor="forgot-email">Email address</label>
                      <input id="forgot-email" type="email" className={`form-input${errors.email ? ' error' : ''}`}
                        placeholder="you@example.com" {...register('email', { required: true })} />
                      {errors.email && <div className="form-error">Email is required</div>}
                    </div>
                    <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                  </form>
                </div>
              </div>
              <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text-sub)' }}>
                <Link to={role === 'landlord' ? '/landlord/login' : '/login'} style={{ color: 'var(--teal)', fontWeight: 600 }}>
                  ← Back to sign in
                </Link>
              </p>
            </>
          ) : (
            <div className="card">
              <div className="card-body" style={{ textAlign: 'center', padding: 32 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>📬</div>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--navy)', marginBottom: 8 }}>Check your email</h2>
                <p style={{ color: 'var(--text-sub)', fontSize: 14, marginBottom: 20 }}>
                  If an account exists with that email, we've sent a password reset link. It expires in 1 hour.
                </p>
                <Link to={role === 'landlord' ? '/landlord/login' : '/login'}>
                  <button className="btn btn-outline" style={{ width: '100%' }}>Back to sign in</button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
